import { useEffect } from "react";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { useAuth } from "@hsbc/auth";
import { HSBC_APP_LINK } from "@hsbc/portal";
import clsx from "clsx";
import "./styles.scss";

export const Timeout = () => {
  const { t } = useI18nContext();
  const auth = useAuth();

  useEffect(() => {
    auth.logout();
  }, [auth]);

  return (
    <div className={clsx("hsbc-timeout-root")}>
      <h2>{t("auth.timeout.title")}</h2>
      <div>
        <Trans
          i18nKey={"auth.timeout.subtitle"}
          components={[
            <a
              href={HSBC_APP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="hsbc app"
            />,
          ]}
        />
      </div>
    </div>
  );
};
